import { MobileDatePicker, LocalizationProvider } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterMoment';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Input } from '../Select/Select.style';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const DatePicker = ({ searched, date, handleChange }) => {
  const { t } = useTranslation();
  const { search } = useLocation();

  const range = useMemo(() => {
    const timestamps = new URLSearchParams(search)?.get('t');
    if (timestamps)
      return {
        max: moment.unix(timestamps.split('-')[1]),
        min: moment.unix(timestamps.split('-')[0]),
      };
  }, [search]);

  useEffect(() => {
    if (searched && searched !== 'Invalid date') {
      handleChange({
        date: {
          string: moment(searched).format('ddd DD MMM'),
          value: moment(searched).format('YYYY-MM-DD'),
        },
      });
    }
  }, [handleChange, searched]);

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <MobileDatePicker
        name="date"
        value={date.value}
        maxDate={range?.max || moment().add(10, 'days')}
        minDate={range?.min}
        onChange={(newValue) => {
          const value = moment(newValue).format('YYYY-MM-DD');
          handleChange({
            date: {
              string: value,
              value: value,
            },
          });
        }}
        disableCloseOnSelect={false}
        label={t('flightstatus.search.date')}
        inputFormat="ddd DD MMM"
        InputProps={{
          disableUnderline: true,
        }}
        showToolbar={false}
        renderInput={(params) => (
          <Input>
            <TextField
              autoComplete="off"
              fullWidth
              variant="standard"
              name="date"
              label={t('flightstatus.search.date')}
              {...params}
            />
          </Input>
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
